<template>
	<div class="product_l">
		<div class="flex_b ">
			<div class=" left_img">
				
				<img :src="ossImgPath+'top1.png'" v-if="index_s<3 &&index_s ==0" class="ranking_b" alt="" />
				<img :src="ossImgPath+'top22.png'" v-if="index_s<3 &&index_s ==1"  class="ranking_b" alt="" />
				<img :src="ossImgPath+'top3.png'" v-if="index_s<3 &&index_s ==2"  class="ranking_b" alt="" />
				<img :src="itemCont.goods_image" alt="" class="goods_img" />
			</div>
			<div class="rg_box_wap">
				<p class="goods_name">{{itemCont.goods_name}}</p>
				<div class="targ">
					<!-- <span class="green" v-if="itemCont.new_products !='' ">{{itemCont.new_products}}</span> -->
						<span class="targ_i " :style="{background:colorList[itemCont.new_products.ptype-1] }" v-if="itemCont.new_products && itemCont.new_products.name !=''" > {{itemCont.new_products.name}}</span>
					<span class="bg_orange" v-if="itemCont.rank_text&&itemCont.rank_text !=''  "  >{{itemCont.rank_text}}</span>
					<span class="bg_black" v-if="itemCont.brand.name !='' && itemCont.brand ">{{itemCont.brand.name}}</span>
					
				</div>
				<div class="color_block flex_b">
					<div>
						<p class="exchange_num" :class="{line_none:itemCont.sales_text ==''}"><strong>{{itemCont.jinbi}}</strong>积分 
						<!-- <b v-if="is_show_retail_price">建议兑换:{{itemCont.retail_price_format}}</b> -->
						</p>
						<div class="exchange_hot" v-if="itemCont.sales_text !=''">
							<iconfont name="iconhuomiao" class="icon" size="0.42rem" color="#FA1549"></iconfont>
							{{itemCont.sales_text}}
						</div>
					</div>
					<div class="exchange_btn">{{isCollec?'兑换':'跟榜兑'}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Iconfont from "@/components/iconfont.vue";
	export default {
		props:{
			index_s:{
				type:[String,Number],
				default:100
			},
			itemCont:{
				type:Object,
				default(){
					return{}
				}
			},
			isCollec:{
				type:Boolean,
				default:false
			},
			is_show_retail_price:{
				type:[String,Number],
				default:0
			}
			
		},
		components: {
			Iconfont
		},
		data(){
			return{
				colorList:['#00B97C','#FF5736','#FFBE00','#F40923']
			}
		}
	}
</script>

<style scoped>
	.rg_box_wap{
		width: 9.06rem;
	}
	.goods_img{
		width: 4rem;
		height: 4rem;	
		display: block;
		border: 0 none;
		border-radius: 0.32rem;
		/* background: #f40; */
	}
	.left_img{
		width: 4rem;
		height: 4rem;	
		position: relative;
		margin-right: 0.4rem; 
	}
	.left_img .ranking_b{
		position: absolute;
		left: 0.2rem;
		top: 0;
		width: 1.24rem;
		height: 1.4rem;
		/* background: blue; */
		
	}
	.product_l{
		padding:0.4rem 0.34rem 0.48rem 0.4rem ;
		/* width:13.46rem; */
		margin: 0 auto 0.4rem;
		background: #fff;
		border-radius: 0.4rem;
	}
	.goods_name{
		color: #333;
		font-size: 0.52rem;
		font-weight: 400;
		/* height: 1.36rem; */
		line-height: 0.74rem;
		overflow: hidden;
		margin-bottom: 0.1rem;
		/* display: block; */
		display: box;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}
	.targ{
		margin-bottom: 0.24rem;
	}
	.targ span{
		border-radius: 0.12rem;
		display: inline-block;
		padding: 0.02rem 0.09rem;
		color: #fff;
		font-size: 0.4rem;
		margin-right: 0.16rem;
		display: inline-block;
	}
	.green{
		background: #00B97C;
	}
	.bg_orange{
		background: #FF8904;
	}
	.targ .bg_black{
		color: #FFDCB1;
		background:#332A1F ;
	}
	.color_block{
		height: 1.6rem;
		/* width: 9.06rem; */
		background: linear-gradient( 90deg, #FFFCFC 0%, #FEE7E7 100%);
		border-radius: 0.32rem;
		padding-left: 0.4rem;
	}
	.exchange_btn{
		padding: 0 0.42rem 0 0.84rem;
		background: url(https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/installMall/Ranking_img.png) 0 0 no-repeat;
		background-size: 100% 100%;
		color: #fff;
		height: 1.62rem;
		line-height: 1.62rem;
		font-size: 0.56rem;
		text-align: center;
		font-weight: bold;
	}
	.exchange_hot{
		color: #FF463A;
		font-size: 0.42rem;
	}
	.exchange_num{
		color: #FF463A;
		font-size: 0.36rem;
		font-weight: 600;
		margin-bottom: 0.1rem;
		height: 0.72rem;
		padding-top: 0.05rem;
	}
	.exchange_num strong{
		font-size: 0.56rem;
		font-weight: bold;
		margin-right: 0.06rem;
	}
	.exchange_num b{
		color: #999999;
		font-size: 0.4rem;
		font-weight: 400;
		/* text-decoration: line-through; */
	}
	
	.over_two_lines{
	    display: -webkit-box;
	    word-break: break-all;
	    text-overflow:ellipsis;
	    overflow: hidden;
	    white-space: pre-line;
	    -webkit-box-orient: vertical;
	    -webkit-line-clamp:2;
	}
	.exchange_num.line_none{
		margin-top: 0.3rem;
	}
</style>